import "./src/styles/global.css";

export const onClientEntry = async () => {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      regs.forEach(r => r.unregister());
      // also nuke SW caches that may hold old page-data/static
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
    }
  } catch {}
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Check if Recite Me is loaded on the window object
  if (typeof window !== "undefined" && window.Recite) {

    // Option A: If the toolbar is active, force it to reload/scan the new content.
    // Recite Me often has a method like enable() or load() to refresh.
    try {
      if (window.Recite.enable && typeof window.Recite.enable === "function") {
        // This ensures Recite is enabled/refreshed
        window.Recite.enable();
      }
    } catch (e) {
      console.error("Recite Me reload failed", e);
    }
  }

  // Option B: Re-attach the 'click' listener to your launch button
  // If your button ID is "reciteme-button" (or similar):
  const launchButton = document.getElementById("reciteme");
  if (launchButton) {
    // Remove old listeners to prevent duplicates (optional but good practice)
    // Note: anonymous functions can't be removed easily, but checking if it works is step 1.

    // Re-attach the launch event (You need your specific loadService or launch function name)
    launchButton.onclick = function () {
      if (window.loadService) {
        window.loadService();
      }
    };
  }
};